import { Mask } from "antd-mobile";
import icon_close from "./../images/icon_close.png";
import icon_mh from "./../images/icon_mh.png";
import icon_rz from "./../images/yz.png";
import "./../index.scss";
export default function Certificate({ visible, setVisible, list }) {
  return (
    <>
      <Mask visible={visible} onMaskClick={() => setVisible(false)}>
        <div className="certificate_box">
          <img
            className="icon_close"
            alt=""
            onClick={() => {
              setVisible(false);
            }}
            src={icon_close}
          />
          <div className="certificate_bg_box">
            <div className="certificate_bg">
              <img
                className="icon_mh"
                alt=""
                style={{ width: "2.67rem" }}
                src={icon_mh}
              />
              <p className="certificate_box_title">区块链存证证书</p>
              <ul className="certificate_list">
                <li>
                  <p className="certificate_list_title">
                    {list.hashname || "存证内容"}
                  </p>
                  <p className="certificate_list_value">
                    {list?.certificateContent}
                  </p>
                </li>
                <li>
                  <p className="certificate_list_title">
                    {list.addressname || "存证地址"}
                  </p>
                  <p className="certificate_list_value">
                    {list?.certificateAddress}
                  </p>
                </li>
                <li>
                  <p className="certificate_list_title">区块高度</p>
                  <p className="certificate_list_value">{list?.blockHeight}</p>
                </li>
              </ul>
              <div className="certificate_rz_box">
                <ul>
                  <li>存证主体：{list?.certificateSubjects}</li>
                  <li>存证时间：{list?.certificateTime}</li>
                  <li>地理位置：{list?.geoLocation}</li>
                </ul>
                <img
                  style={{ width: "1.67rem", height: "1.67rem" }}
                  alt=""
                  src={icon_rz}
                />
              </div>
              <p className="certificate_rz_tip">
                全流程记录，全链路可信，全节点见证
              </p>
            </div>
          </div>
        </div>
      </Mask>
    </>
  );
}
